const hostedApp = (name, slug, note) => ({
  name,
  url: `/apps/${slug}/`,
  ...(note ? { note } : {}),
});

export const PUBLIC_APPLICATIONS = [
  hostedApp('Dominion Tech Solutions', 'dominion-tech-solutions'),
  hostedApp('KGIS Mobile', 'kgis-mobile'),
  hostedApp('Kingdom Network Tracker', 'kvin-network-tracker'),
  hostedApp('Kingdom Auctions', 'kingdom-auctions'),
  hostedApp('Kingdom Business Directory', 'kingdom-business-directory'),
  hostedApp('Kingdom Chamber of Commerce', 'kingdom-chamber-of-commerce'),
  hostedApp('Kingdom Comms - TikTok', 'kingdom-comms-tiktok'),
  hostedApp('Kingdom Conferences', 'kingdom-conferences'),
  hostedApp('Kingdom Construction', 'kingdom-construction'),
  hostedApp('Kingdom Counselling', 'kingdom-counselling'),
  hostedApp('Kingdom Family Tracker', 'kingdom-family-tracker'),
  hostedApp('Kingdom Fitness', 'kingdom-fitness'),
  hostedApp('Kingdom Friendship Circle', 'kingdom-friendship-circle'),
  hostedApp('Kingdom GPS', 'kingdom-gps'),
  hostedApp('Kingdom Global Intelligence System - KGIS', 'kingdom-global-intelligence-system'),
  hostedApp('Kingdom Invitation', 'kingdom-invitation'),
  hostedApp('Kingdom KJV', 'kingdom-kjv'),
  hostedApp('Kingdom Meals', 'kingdom-meals'),
  hostedApp('Kingdom Medical Care', 'kingdom-medical-care', 'Static version imported; bundled Node backend still needs Laravel migration.'),
  hostedApp('Kingdom Music Studio', 'kingdom-music-studio'),
  hostedApp('Kingdom Personal Assistant', 'kingdom-pa', 'Static version imported; bundled Node backend still needs Laravel migration.'),
  hostedApp('Kingdom Political Intelligence Portal', 'kingdom-political-intelligence'),
  hostedApp('Kingdom Social Services', 'kingdom-social-services'),
  hostedApp('Kingdom Staff Record', 'kingdom-staff-record', 'Laravel database backend included.'),
  hostedApp('Kingdom Vehicle Evaluation', 'kingdom-vehicle-evaluation', 'Static version imported; bundled Node backend still needs Laravel migration.'),
  hostedApp('Vehicle Evaluation', 'vehicle-evaluation'),
  hostedApp('Kingdom Virtual Crowd - Christian Facebook', 'kingdom-virtual-crowd'),
  hostedApp('Kingdom Women in Battle', 'kingdom-women-in-battle'),
  hostedApp('Kingdom Young Lions Youth Ministry', 'kingdom-young-lions-youth-ministry'),
  hostedApp('Kingdom Mighty Men Ministry', 'kingdom-mighty-men-ministry'),
  hostedApp('Kingdom Podcasts', 'kingdom-podcasts'),
  hostedApp('SA Political Parties Analysis', 'sa-political-parties-analysis'),
  hostedApp('KCBLC', 'kcblc'),
  {
    name: 'Kingdom Audio Bible with Explanations',
    url: '',
    note: 'Source JSX was found, but no compiled index.html was included.',
  },
  {
    name: 'Kingdom Bible College',
    url: '',
    note: 'Source JSX was found, but no compiled index.html was included.',
  },
  {
    name: 'Kingdom Events',
    url: '',
    note: 'The ZIP includes an empty index.html and source JSX; it needs to be compiled before hosting.',
  },
  {
    name: 'Kingdom Vision Farmers Market',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kingdom Vision Frail Care',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kingdom Vision Healthcare Directory',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kingdom Vision Virtual House Church',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kleinhans Holdings Registrations',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Prayer Group',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kingdom Vision Sales & Swaps',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Security Company Listing',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Vehicle Sales',
    url: '',
    note: 'ZIP contains an empty folder only.',
  },
  {
    name: 'Kingdom Vision Launch App',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Presenters Applications',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Vision Security',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Jobs/Employment',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Vision Properties',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Daily Dashboard',
    url: '',
    note: 'Netlify link removed; copy the app files into Apps/ to host it locally.',
  },
  {
    name: 'Kingdom Embassy Herald',
    url: '',
    note: 'Link pending',
  },
];
